/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import moment from 'moment';

import Button from 'components/form/Button.component';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import { withTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import {
  changeCommissionRate,
  createCommissionRate,
  getAllCommissionReport,
  getCommissionReport,
  setGlobalDiscount,
} from 'reports/actions';
import RevenueCommissionTableContainer from 'reports/Commissions/RevenueCommissionTable';
import HeaderMenu from 'reports/Common/HeaderMenu';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import { Tables } from 'reports/consts';

import CN from './CommissionsLayout.module.scss';

const ReportsProps = ['salesReport'];

class CommissionsLayout extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: 'Commissions',
        items: [
          {
            id: Tables.CountOfServices,
            name: 'Counts of Services',
            onClick: () => {
              this.setTables(Tables.CountOfServices);
            },
          },
          {
            id: Tables.CategoryServiceAndProduct,
            name: 'Staff Commission calculator',
            onClick: () => {
              this.setTables(Tables.CategoryServiceAndProduct);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.setTables(Tables.CategoryServiceAndProduct);
  }

  createCommissionRate = (stylistId, data) => void this.props.createCommissionRate(this.props.salonId, stylistId, data);
  changeCommissionRate = (stylistId, data) => void this.props.changeCommissionRate(this.props.salonId, stylistId, data);
  getCommissionReport = (stylistId) => void this.props.getCommissionReport(this.props.salonId, stylistId);
  setGlobalDiscount = (discount) => void this.props.setGlobalDiscount(this.props.salonId, discount);
  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const { salonId, isDarkMode } = this.props;

    const linkCommissions = linkTo({ pattern: LINK.hrCommissions, params: { salonId } });

    return (
      <div
        className={cn({
          'has-protipbox commissions': true,
          [CN.component]: true,
          [CN.dark]: isDarkMode,
        })}
      >
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          <HeaderMenu data={this.state.headerData} selectedId={this.state.shownTables} />
          {this.props.salesReport.lastRequestResponse && (
            <div>
              <div className={CN.panel}>
                <div className={CN.flex}>
                  <div className={CN.panelContainer}>
                    <div className={CN.panelText}>
                      <span className={CN.extraBold}>{S.lamp} Pro tip:</span> Ensure all appointments are checked out to
                      allocate revenue share correctly per staff member
                    </div>
                    <div className={CN.panelText}>
                      <span className={CN.extraBold}>{S.lamp} Pro tip:</span> To see figures excluding VAT, type 20 into
                      the VAT / Deductible tax rate box in the top right
                    </div>
                  </div>
                  <div className={CN.buttonsContainer}>
                    <Button variant="primaryForce" xSpace>
                      <NavLink to={linkCommissions}>
                        <div className={CN.buttonText}>EDIT STAFF COMMISSION RATES</div>
                      </NavLink>
                    </Button>
                  </div>
                </div>
              </div>
              <RevenueCommissionTableContainer
                startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                salonVatRate={this.props.salonVatRate}
                createCommissionRate={this.createCommissionRate}
                changeCommissionRate={this.changeCommissionRate}
                data={this.props.salesReport.lastRequestResponse.stylist_group}
                allCommissionReport={this.props.allCommissionReport.lastRequestResponse}
                getAllCommissionReport={this.props.getAllCommissionReport}
                salonId={this.props.salonId}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
    reports,
  } = state;
  const {
    uniqueVisitsReport,
    salesReport,
    commissionReport,
    globalDiscount,
    salonVatRate,
    allCommissionReport,
    isFetching,
  } = reports;
  return {
    uniqueVisitsReport,
    salonId,
    salesReport,
    salonVatRate,
    commissionReport,
    allCommissionReport,
    isFetching,
    globalDiscount: globalDiscount.discount,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    setGlobalDiscount(salonId, globalDiscount) {
      dispatch(setGlobalDiscount(salonId, globalDiscount));
    },
    createCommissionRate(salonId, stylistId, data) {
      dispatch(createCommissionRate(salonId, stylistId, data));
    },
    changeCommissionRate(salonId, stylistId, data) {
      dispatch(changeCommissionRate(salonId, stylistId, data));
    },
    getCommissionReport(salonId, stylistId) {
      dispatch(getCommissionReport(salonId, stylistId));
    },
    getAllCommissionReport(salonId) {
      dispatch(getAllCommissionReport(salonId));
    },
  };
}

const CommissionsLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withTheme()(CommissionsLayout));

export default CommissionsLayoutHoc;
